import { userV } from '../../domainServices/UserService';
import { fetchWrapper } from '../fetchWrapper';

export function getUser(id: string) {
  return fetchWrapper({ url: `/api/user/${id}`, dataType: userV });
}
